import { Container } from '../../Container/Container';
import Form from './components/Form/Form';
import styles from './AuthPage.module.scss';
import useAuth from '../../../hooks/useAuth';
import { Navigate, useLocation } from 'react-router-dom';

const AuthPage = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  return isAuthenticated === true ? (
    <Navigate to="/account" state={{ from: location }} replace />
  ) : (
    <Container className={styles.AuthPage}>
      <h1>Авторизация</h1>
      <p>Добро пожаловать в техническую документацию Groupe SEB</p>
      <div className={styles.form_holder}>
        <Form />
      </div>
      <picture>
        <source
          srcSet="/images/auth/backgroundLogoMob.svg"
          media="(width < 1024px)"
        />
        <img
          className={styles.background}
          src="/images/auth/backgroundLogo.svg"
          alt=""
        />
      </picture>
    </Container>
  );
};

export default AuthPage;
